import { useEffect, useState } from 'react';
import { UnBoxArrayType } from '~/utils';
import { StaticProps } from '~/context';
import { queryParametersSchema, QueryParameters, QueryParametersKey, QueryParametersValue } from '~/schema';

export type FilterSummaryItem<Key extends QueryParametersKey = QueryParametersKey> = {
  key: string;
  label: string;
  filterKey: Key;
  value: UnBoxArrayType<QueryParametersValue<Key>>;
};

interface FilterSummaryProps {
  staticProps: StaticProps;
  queryParameters: QueryParameters;
}
export const useFilterSummary = ({ queryParameters, staticProps }: FilterSummaryProps) => {
  const [state, setState] = useState<FilterSummaryItem[]>([]);

  useEffect(() => {
    setState((currentFilterSummary) => summarize(currentFilterSummary, queryParameters, staticProps));
  }, [staticProps, queryParameters]);

  return { filterSummaries: state };
};

function summarize(
  currentFilterSummary: FilterSummaryItem[],
  queryParameters: FilterSummaryProps['queryParameters'],
  staticProps: FilterSummaryProps['staticProps']
) {
  const newUids: string[] = [];
  const existingKeys = currentFilterSummary.map((fs) => fs.key);
  let summaries: FilterSummaryItem[] = [...currentFilterSummary];
  queryParametersSchema.parameters.forEach((parameter) => {
    if (!parameter.getSummaryItems) return;
    const value = parameter.getValue({ staticProps, queryParameters });
    const defaultValue = parameter.getDefaultValue({ initialQueryParameters: staticProps.initialQueryParameter });
    const result = parameter.getSummaryItems({
      value,
      defaultValue,
      staticProps,
      queryParameters,
    });
    if (!result || result.length === 0) return;

    result.forEach((nfs) => newUids.push(nfs.key));
    summaries = [...summaries, ...result.filter((nfs) => !existingKeys.includes(nfs.key))];
  });
  return summaries.filter((efs) => newUids.includes(efs.key));
}
